
























































































































































































































import { Component, Prop, Emit, Watch } from 'vue-property-decorator'
import { State } from 'vuex-class'
import { dateTimeToDisplay, dateToDisplay, dateToNow } from '@/utils/dateTime'
import FoldingCard from '@/components/FoldingCard.vue'
import { mixins } from 'vue-class-component'
import { Case } from '@/modules/Newcase/interfaces/case'
import AccountAssets from '@/modules/Newcase/components/AccountAssets.vue'
import AccountCertificates from '@/modules/Newcase/components/AccountCertificates.vue'
import CaseAttachmentsCard from '../components/CaseAttachmentCard.vue'
import AccountInfo from '@/modules/Newcase/components/AccountInfo.vue'
import CasePolicyInfo from '../components/CasePolicyInfo.vue'
import CasePolicyDocusign from '../components/CasePolicyDocusign.vue'
import CaseFoldingCard from '@/modules/Newcase/components/CaseFoldingCard.vue'
import { Task } from '@/modules/Task/interfaces/task'
import { taskStatus, taskPriority } from '@/modules/Task/helpers/task'
import { showErrors, showNotification } from '@/utils/snack'
import { SnackType } from '@/interfaces/snack'
import AppDialog from '@/components/AppDialog.vue'
import AppTextarea from '@/components/AppTextarea.vue'
import { newNote, editNote, deleteNoteById, getCaseHistories, newInsuranceCaseNote, editInsuranceCaseNote, deleteInsuranceCaseNoteById } from '@/modules/Newcase/gql/case.gql'
import { Note } from '@/modules/Newcase/interfaces/note'
import { User } from '@/modules/User/interfaces/user'
import TaskDialog from '@/modules/Task/scripts/task-dialog'
import { ProducerNote } from '../interfaces/producer-note'

@Component({
  components: {
    FoldingCard,
    AccountAssets,
    AccountCertificates,
    CaseAttachmentsCard,
    AccountInfo,
    CasePolicyInfo,
    CasePolicyDocusign,
    CaseFoldingCard,
    AppDialog,
    AppTextarea
  }
})
export default class CaseNoteDrawer extends mixins(TaskDialog) {
  @Prop({ type: Object as () => Case }) readonly caseInfo!: Case
  @Prop({ type: Number }) readonly initTab!: number

  folding = false
  dialogShow = false
  disableConfirm = false

  dateTimeToDisplay = dateTimeToDisplay
  dateToDisplay = dateToDisplay
  dateToNow = dateToNow

  taskStatus = taskStatus
  taskPriority = taskPriority

  newNote = ''
  checkedNote: Note | null = null
  edittingNote = ''
  isShowDeleteDialog = false
  deleting = false

  newProducerNote = ''
  checkedProducerNote: ProducerNote | null = null
  replyingNote = false
  deletingProducerNote = false

  tabIndex = 0

  @State(state => state.user.me) me!: User

  get noteList () {
    return (this.caseInfo.notes || []).sort((a, b) => {
      return +b.createdAt - +a.createdAt
    })
  }

  get producerNoteList () {
    return (this.caseInfo.insuranceCaseNotes || []).sort((a, b) => {
      return +b.createdAt - +a.createdAt
    })
  }

  get taskList () {
    return (this.caseInfo.tasks || [])
  }

  mounted () {
    this.tabIndex = this.initTab
  }

  @Watch('tabIndex')
  onTabChanged (val: number) {
    if (val === 1) {

    }
  }

  hideActionDialog () {
    this.dialogShow = false
  }

  closingHandler () {
    this.folding = true
    setTimeout(() => {
      this.onClose()
    }, 500)
  }

  cancelProducerNoteHandler () {
    this.checkedProducerNote = null
    this.newProducerNote = ''
    this.replyingNote = false
  }

  async newNoteHandler () {
    const { id } = this.caseInfo

    if (!this.newNote) {
      return
    }

    try {
      const result = await this.$apollo.mutate({
        mutation: newNote,
        variables: {
          noteInput: {
            content: this.newNote,
            masterId: Number(id),
            masterType: 'CASE'
          }
        }
      })

      const res = result.data.newNote
      if (res) {
        showNotification({
          msg: 'New note successfully',
          type: SnackType.Success
        })
        this.newNote = ''
        this.onSuccess()
      }
    } catch (error) {
      showErrors(error.graphQLErrors)
    }
  }

  async newProducerNoteHandler () {
    const { id } = this.caseInfo

    if (!this.newProducerNote) {
      return
    }

    try {
      const result = await this.$apollo.mutate({
        mutation: newInsuranceCaseNote,
        variables: {
          insuranceCaseNoteInput: {
            content: this.newProducerNote,
            caseId: Number(id),
            replyToId: this.checkedProducerNote ? +this.checkedProducerNote.id : undefined
          }
        }
      })

      const res = result.data.newInsuranceCaseNote
      if (res) {
        showNotification({
          msg: 'New note successfully',
          type: SnackType.Success
        })
        this.newProducerNote = ''
        this.replyingNote = false
        this.onSuccess()
      }
    } catch (error) {
      showErrors(error.graphQLErrors)
    }
  }

  generateAssignTo (item: Task) {
    const { assignedTo } = item

    return assignedTo.reduce((prev, curr, currIdx) => {
      if (currIdx === assignedTo.length - 1) {
        return prev + curr.username
      } else {
        return prev + curr.username + ', '
      }
    }, '')
  }

  ifEditting (item: Note) {
    return (this.checkedNote && item.id === this.checkedNote.id) && !this.deleting
  }

  editNote (item: Note) {
    this.checkedNote = item
    this.edittingNote = item.content
  }

  deleteNote (item: Note) {
    this.deleting = true
    this.checkedNote = item
    this.isShowDeleteDialog = true
  }

  deleteProducerNote (item: ProducerNote) {
    this.deletingProducerNote = true
    this.checkedProducerNote = item
    this.isShowDeleteDialog = true
  }

  splitNoteContent (content: string) {
    if (!content) return []
    return content.split('\n')
  }

  replyProducerNoteHandler (item: ProducerNote) {
    this.checkedProducerNote = item
    this.replyingNote = true
  }

  async editNoteHandler () {
    if (!this.checkedNote || !this.edittingNote) {
      return
    }
    const { id } = this.caseInfo
    try {
      const result = await this.$apollo.mutate({
        mutation: editNote,
        variables: {
          noteInput: {
            content: this.edittingNote,
            masterId: Number(id),
            masterType: 'CASE'
          },
          noteId: Number(this.checkedNote.id)
        }
      })

      const res = result.data.editNote
      if (res) {
        showNotification({
          msg: 'Edit note successfully',
          type: SnackType.Success
        })
        this.edittingNote = ''
        this.checkedNote = null
        this.onSuccess()
      }
    } catch (error) {
      showErrors(error.graphQLErrors)
    }
  }

  deleteConfirm () {
    if (this.deleting) {
      this.deleteNoteConfirm()
    }

    if (this.deletingProducerNote) {
      this.deleteProducerNoteConfirm()
    }
  }

  async deleteNoteConfirm () {
    if (!this.checkedNote) {
      return
    }
    const { id } = this.checkedNote
    try {
      const result = await this.$apollo.mutate({
        mutation: deleteNoteById,
        variables: {
          noteId: Number(id)
        }
      })

      const res = result.data.deleteNoteById
      if (res) {
        showNotification({
          msg: 'Delete note successfully',
          type: SnackType.Success
        })
        this.isShowDeleteDialog = false
        this.newNote = ''
        this.checkedNote = null
        this.onSuccess()
      }

      this.deleting = false
    } catch (error) {
      showErrors(error.graphQLErrors)
    }
  }

  async deleteProducerNoteConfirm () {
    if (!this.checkedProducerNote) {
      return
    }
    const { id } = this.checkedProducerNote
    try {
      const result = await this.$apollo.mutate({
        mutation: deleteInsuranceCaseNoteById,
        variables: {
          insuranceCaseNoteId: Number(id)
        }
      })

      const res = result.data.deleteInsuranceCaseNoteById
      if (res) {
        showNotification({
          msg: 'Delete note successfully',
          type: SnackType.Success
        })
        this.isShowDeleteDialog = false
        this.newProducerNote = ''
        this.checkedProducerNote = null
        this.onSuccess()
      }

      this.deleting = false
    } catch (error) {
      showErrors(error.graphQLErrors)
    }
  }

  cancelEditting () {
    this.checkedNote = null
    this.checkedProducerNote = null
  }

  onDeleteCancel () {
    this.checkedNote = null
    this.checkedProducerNote = null
    this.deleting = false
    this.deletingProducerNote = false
  }

  onSuccessHandler () {
    this.hideTaskDialog()
    this.onSuccess()
  }

  handleTaskDetail (task: any) {
    const path = this.$router.resolve(
      { name: 'TaskDetail',
        params: { id: task.id }
      }
    )
    window.open(path.href, '_blank')
  }

  onTabClick (index: number) {
    this.tabIndex = index
  }

  @Emit('close')
  onClose () {
    // do nothing
  }

  @Emit('complete')
  onComplete () {
    // do nothing
  }

  @Emit('success')
  onSuccess () {
    // do nothing
  }
}
